import { atom } from 'jotai';
import type { User } from '@tier4/webauto-auth-frontend-client';

export const isAuthErrorAtom = atom(false);

export const userAtom = atom<User | null>(null);
